export default __webpack_public_path__ + "static/media/kitchen5-beforeE-1440w.3cec2e26.avif";